import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "text-gray-900 text-lg mb-6 font-medium" }
const _hoisted_3 = { class: "text-white mb-6 p-3 rounded-lg bg-blue-600 w-full font-semibold" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "flex justify-between items-center mb-6 w-full flex-wrap" }
const _hoisted_7 = { class: "relative max-sm:mb-2" }
const _hoisted_8 = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }
const _hoisted_9 = { class: "flex gap-6 items-end" }
const _hoisted_10 = {
  for: "class-filter",
  class: "block text-sm font-medium text-gray-700 mb-1"
}
const _hoisted_11 = { value: "" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "w-full" }
const _hoisted_14 = { class: "border-y border-y-gray-200 border-l border-l-gray-200 py-3 text-gray-600 font-medium text-xs text-start pl-6" }
const _hoisted_15 = { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }
const _hoisted_16 = { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }
const _hoisted_17 = { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }
const _hoisted_18 = { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("th", { class: "border-y border-y-gray-200 py-3 text-gray-600 font-medium text-xs text-start" }, "Student number", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("th", { class: "border-y border-y-gray-200 border-r border-r-gray-200 py-3 text-gray-600 font-medium text-xs text-start pr-6" }, "Password", -1)
const _hoisted_21 = { class: "text-gray-900 text-sm font-medium py-6 border-b border-b-gray-200 pl-6 border-l border-l-gray-200" }
const _hoisted_22 = ["value", "disabled"]
const _hoisted_23 = { class: "text-gray-900 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_24 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_25 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_26 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_27 = { class: "flex justify-start items-center gap-2" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "text-gray-600 text-sm py-6 border-b border-b-gray-200 pr-6 border-r border-r-gray-200" }, "Password", -1)
const _hoisted_33 = { class: "flex justify-center items-center mt-4 space-x-4" }
const _hoisted_34 = { class: "flex items-center space-x-1" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex justify-between mt-6 w-full" }
const _hoisted_37 = { class: "w-full flex flex-col justify-center items-center" }
const _hoisted_38 = { class: "w-full relative transform overflow-hidden text-left transition-all border border-gray-300 bg-white rounded-lg" }
const _hoisted_39 = { class: "text-center" }
const _hoisted_40 = { class: "flex justify-between border-b border-b-2 border-gray-200" }
const _hoisted_41 = { class: "text-lg text-gray-900 font-semibold p-6" }
const _hoisted_42 = { class: "w-full max-h-[30rem] overflow-y-scroll" }
const _hoisted_43 = { class: "table-auto w-full divide-y divide-gray-300" }
const _hoisted_44 = { class: "rounded-lg" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("th", { class: "text-start text-xs text-gray-600 font-medium py-3 pl-6" }, null, -1)
const _hoisted_46 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_47 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_48 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_49 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_50 = { class: "text-start text-xs text-gray-600 font-medium py-3" }
const _hoisted_51 = { class: "divide-y divide-gray-200" }
const _hoisted_52 = { class: "text-sm text-gray-600 py-6 text-left pl-6" }
const _hoisted_53 = { class: "text-sm text-gray-500 py-6 text-left" }
const _hoisted_54 = { class: "text-sm text-gray-900 font-medium py-6 text-left" }
const _hoisted_55 = { class: "text-sm text-gray-900 font-medium py-6 text-left" }
const _hoisted_56 = { class: "text-sm text-gray-600 py-6 text-left" }
const _hoisted_57 = { class: "text-sm text-gray-600 py-6 text-left" }
const _hoisted_58 = { class: "w-full flex justify-between items-center px-8 py-6" }
const _hoisted_59 = { class: "" }
const _hoisted_60 = { class: "h-5 w-4 [&>svg]:stroke-current [&>svg]:h-5" }
const _hoisted_61 = { class: "flex items-center" }
const _hoisted_62 = { class: "p-8" }
const _hoisted_63 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_64 = { class: "mt-6 text-center" }
const _hoisted_65 = { class: "text-2xl font-semibold leading-6 text-gray-900" }
const _hoisted_66 = { class: "mt-4 text-center" }
const _hoisted_67 = { class: "text-sm text-gray-600" }
const _hoisted_68 = { class: "text-gray-600" }
const _hoisted_69 = { class: "mt-6 flex justify-around items-center gap-3" }

import { computed, ref, watch, onBeforeMount, onMounted } from 'vue';
import { useLearnerStore } from "@/stores/learnerStore";
import { useRolloverStore } from "@/stores/rolloverStore";
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from '@/stores/subjectStore';
import { MagnifyingGlassIcon } from "@heroicons/vue/24/outline";
import bulkUploadLearners from "../components/BulkLearnersUploadComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnassignedStudentsTable',
  props: {
  classData: {
    type: Object,
    required: true
  },
  selectedClassData: {
    type: Object,
    required: true
  }
},
  emits: ['update-selected-count', 'hideTable', 'learnersToUpload', 'new-learners', 'initial-student-counts'],
  setup(__props, { emit }) {

const props = __props;

const learnerStore = useLearnerStore();
const rolloverStore = useRolloverStore();
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();



// Track the header checkbox and selected learners
const selectAll = ref(false);
const selectedLearners = ref<string[]>([]);
// bulk upload
const showGenerateEmails = ref(false);
const learnersToUpload = ref<any>([]);
const showLearnersUploadPreview = ref(false);
const isSubmitting = ref(false);
// pagination
const currentPage = ref(1);
const itemsPerPage = ref(16);
// Search query for filtering learners
const searchQuery = ref("");
// Store all the data in an object and add it to another table
const storedData = ref<any[]>([]);

// calcuate which subject it is
const mathsSubject = subjectStore.getSubjects[0].id;

const learners = computed(() => {
  return learnerStore.getSchoolLearners
    .filter((learner) => learner.grade === props.selectedClassData.gradeLevel) // Filter by grade level
    .map((learner) => {
      // Check if learner is assigned to a class of the same subject and grade level
      const isAssignedToSelectedClass = learner.classes?.some(
        (assignedClass) =>
          assignedClass.subject._id === props.selectedClassData.subject && // Same subject
          assignedClass.gradeLevel === props.selectedClassData.gradeLevel && // Same grade level
          assignedClass._id === props.selectedClassData._id // Assigned to the selected class
      );

      const isAssignedToOtherClass = learner.classes?.some(
        (assignedClass) =>
          assignedClass.subject._id === props.selectedClassData.subject && // Same subject
          assignedClass.gradeLevel === props.selectedClassData.gradeLevel && // Same grade level
          assignedClass._id !== props.selectedClassData._id // But assigned to a different class of the same subject and grade
      );

      // If the learner is assigned to a different class of the same subject and grade, hide them
      if (isAssignedToOtherClass) {
        return null;
      }

      // Automatically include assigned learners in the `selectedLearners` array
      if (isAssignedToSelectedClass && !selectedLearners.value.includes(learner._id)) {
        selectedLearners.value.push(learner._id);
      }

      return {
        ...learner,
        isAssigned: isAssignedToSelectedClass, // Mark if the learner is assigned to the selected class
      };
    })
    .filter(Boolean) // Remove null values (learners who are assigned to other classes of the same subject)
    .sort((a, b) => {
      // Sort alphabetically by last name only
      const lastNameA = a.lastName.toLowerCase();
      const lastNameB = b.lastName.toLowerCase();
      return lastNameA.localeCompare(lastNameB); // Compare alphabetically by last name
    });
});

const onFormSubmit = (formData: any) => {
  const dataToStore = learnersToUpload.value

  storedData.value.push(...dataToStore);
  // Clear selected learners
  learnersToUpload.value = [];
  
  showLearnersUploadPreview.value = false;
};

const classList = computed(() =>
  schoolStore?.currentSchoolStructure?.classGroups.map((classGroup) => ({
    name: classGroup.name,
    _id: classGroup._id,
  }))
);

// Create a lookup map for class IDs to names
const classMap = computed(() => {
  return (classList.value ?? []).reduce((map: Record<string, string>, classGroup) => {
    map[classGroup._id] = classGroup.name;
    return map;
  }, {} as Record<string, string>);
});

const fetchPreviousClasses = async () => {
  const currentSchool = schoolStore.getCurrentSchool;
  if (currentSchool) {
    await rolloverStore.fetchSchoolRollover(currentSchool._id);
  }

  return;
};

onBeforeMount(async () => {
  await fetchPreviousClasses();
});

watch(() => props.selectedClassData, async () => {
  await fetchPreviousClasses();
});

const learnersWithPreviousClasses = computed(() => {
  // Map previous classes for each learner
  const previousClassesMap = rolloverStore?.getRollover?.learnerPreviousClasses.reduce(
    (acc: Record<string,any>, curr: any) => {
      acc[curr.learner] = curr.previousClasses;
      return acc;
    },
    {} as Record<string, any>
  );

  // Combine learner data with their previous classes' details
  return learners.value.map((learner) => ({
    ...learner,
    previousClasses: (previousClassesMap?.[learner._id] || []).map(
      (classId: any) => ({
        id: classId,
        name: classMap.value[classId] || "Unknown Class",
      })
    ),
  }));
});

// Watch selectAll to update row checkboxes
const toggleSelectAll = () => {
  const allLearners = [...learners.value, ...storedData.value];
  selectedLearners.value = selectAll.value ? allLearners.map((learner) => learner._id) : [];
};

watch(selectedLearners, (newVal) => {
  const allLearners = [...learners.value, ...storedData.value];
  selectAll.value = newVal.length === allLearners.length;
});

// Function to handle the reception of uploaded learners
const receiveLearnersToUpload = (learners: any) => {
  // console.log("Learners Received: ", learners);
  learnersToUpload.value = JSON.parse(JSON.stringify(learners));
  showLearnersUploadPreview.value = true;
};

const clearPreviewLearners = () => {
  // Clearing the uploaded learners and resetting the UI state
  learnersToUpload.value = [];
  showGenerateEmails.value = false;
  showLearnersUploadPreview.value = false;
};

// Emit events to parent components


// add learners to class
const loadingSubmit = ref(false);

const addLearnersToClass = computed(() => () => {
  loadingSubmit.value = true;
  emit('update-selected-count', {
    count: selectedLearners.value.length,
    classId: props.selectedClassData._id,
  });
  emit('new-learners', {
    learners: selectedLearners.value,
    classId: props.selectedClassData._id,
  });
  loadingSubmit.value = false;
  confirmAssignLearnersModal.value = false;
  emit('hideTable');
});

onMounted(() => {
  const initialCounts = {
    [props.selectedClassData._id]: selectedLearners.value.length,
  };
  emit('initial-student-counts', { counts: initialCounts });
});

const goBack = () => {
  emit('hideTable');
};

// confirm modal 
const confirmAssignLearnersModal = ref(false);

const confirmAssignLearners = () => {
  confirmAssignLearnersModal.value = true;
};


// Computed properties for pagination
const paginatedLearners = computed(() => {
  const start = (currentPage.value - 1) * itemsPerPage.value;
  const end = start + itemsPerPage.value;
  return filteredLearners.value.slice(start, end);
});

const totalPages = computed(() =>
  Math.ceil(filteredLearners.value.length / itemsPerPage.value)
);

// previous classes filter
const selectedClassFilter = ref("");

// Generate unique previous classes for the dropdown
const uniquePreviousClasses = computed(() => {
  const allClasses = learnersWithPreviousClasses.value.flatMap((learner) =>
    learner.previousClasses.map((classDetails: any) => classDetails.id.name)
  );
  return [...new Set(allClasses)];
});

// Filter learners by search query and selected previous class
const filteredLearners = computed(() => {
  let allLearners = [
    ...learnersWithPreviousClasses.value,
    ...storedData.value,
  ];

  if (selectedClassFilter.value) {
    allLearners = allLearners.filter((learner) =>
      learner.previousClasses.some(
        (classDetails: any) =>
          classDetails.id.name === selectedClassFilter.value &&
          classDetails.id.subject.name === props.classData.subjectName
      )
    );
  }

  if (searchQuery.value) {
    const query = searchQuery.value.toLowerCase();
    allLearners = allLearners.filter(
      (learner) =>
        learner.firstName.toLowerCase().includes(query) ||
        learner.lastName.toLowerCase().includes(query)
    );
  }

  return allLearners;
});

return (_ctx: any,_cache: any) => {
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.header")), 1),
      _createElementVNode("h2", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.class")) + " " + _toDisplayString(__props.classData.name) + " - ", 1),
        (__props.classData.subject === _unref(mathsSubject))
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "M"))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, "E"))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(MagnifyingGlassIcon), {
              class: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            placeholder: "Search",
            class: "w-full rounded-md border-0 bg-white py-2.5 pl-10 pr-10 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm sm:leading-6"
          }, null, 512), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.previous_class_label")) + ": ", 1),
            _withDirectives(_createElementVNode("select", {
              id: "class-filter",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedClassFilter).value = $event)),
              class: "text-gray-700 text-semibold py-2.5 px-4 rounded-lg flex gap-1 border border-gray-300 w-full"
            }, [
              _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.all_classes_text")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(uniquePreviousClasses.value, (className) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: className,
                  value: className
                }, _toDisplayString(className), 9, _hoisted_12))
              }), 128))
            ], 512), [
              [_vModelSelect, selectedClassFilter.value]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("table", _hoisted_13, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "h-4 w-4 border border-blue-600 text-blue-600 focus:ring-blue-600",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectAll).value = $event)),
                  onChange: toggleSelectAll
                }, null, 544), [
                  [_vModelCheckbox, selectAll.value]
                ])
              ]),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.last_name")), 1),
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.first_name")), 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.email")), 1),
              _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.previous_class")), 1),
              _hoisted_19,
              _hoisted_20
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedLearners.value, (learner) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: learner._id
              }, [
                _createElementVNode("td", _hoisted_21, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    class: "h-4 w-4 border border-blue-600 text-blue-600 focus:ring-blue-600",
                    value: learner._id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedLearners).value = $event)),
                    disabled: learner.isAssigned
                  }, null, 8, _hoisted_22), [
                    [_vModelCheckbox, selectedLearners.value]
                  ])
                ]),
                _createElementVNode("td", _hoisted_23, _toDisplayString(learner.lastName), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(learner.firstName), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(learner.email), 1),
                _createElementVNode("td", _hoisted_26, [
                  _createElementVNode("ul", _hoisted_27, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learner.previousClasses, (classDetails) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: classDetails.id
                      }, [
                        (__props.classData.subjectName === classDetails.id.subject.name)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(classDetails.id.name), 1))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("td", _hoisted_29, [
                  (learner.studentNumber)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(learner.studentNumber), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_31, "null"))
                ]),
                _hoisted_32
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(totalPages.value, (page) => {
              return (_openBlock(), _createElementBlock("button", {
                key: page,
                class: _normalizeClass(["text-tertiary rounded-sm p-2 text-xs font-medium w-6 h-6 leading-none flex justify-center items-center", { '!text-dark-blue': currentPage.value === page }]),
                onClick: ($event: any) => (currentPage.value = page)
              }, _toDisplayString(page), 11, _hoisted_35))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("button", {
            class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2.5 px-4",
            onClick: goBack
          }, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.back")), 1),
          _createElementVNode("button", {
            class: "px-4 py-2.5 text-white bg-blue-600 border border-blue-600 rounded-lg font-semibold flex items-center",
            onClick: confirmAssignLearners
          }, [
            (loadingSubmit.value)
              ? (_openBlock(), _createBlock(_component_spinner_loader, {
                  key: 0,
                  color: 'text-white dark:text-white mr-2'
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.submit")), 1)
          ])
        ])
      ])
    ]),
    (showGenerateEmails.value)
      ? (_openBlock(), _createBlock(bulkUploadLearners, {
          key: 0,
          classId: __props.selectedClassData._id,
          className: __props.selectedClassData.name,
          onTransmitLearnersToUpload: receiveLearnersToUpload,
          onResetModalState: _cache[4] || (_cache[4] = ($event: any) => (showGenerateEmails.value = false))
        }, null, 8, ["classId", "className"]))
      : _createCommentVNode("", true),
    _createVNode(_component_modal, {
      widthClass: 'max-w-5xl',
      open: showLearnersUploadPreview.value,
      onLocalModalOpen: _cache[5] || (_cache[5] = ($event: any) => (showLearnersUploadPreview.value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          type: "form",
          actions: false,
          ref: "learnersForm",
          onSubmit: onFormSubmit,
          onSubmitInvalid: _ctx.onFormInvalid,
          "validation-errors": _ctx.formErrors,
          classes: {
        message: 'text-red-500 text-xs px-8 pb-6',
      }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("h3", _hoisted_41, _toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.header")), 1)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("table", _hoisted_43, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("th", _hoisted_46, _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.preview_learners.table.email"
                        )), 1),
                          _createElementVNode("th", _hoisted_47, _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.preview_learners.table.first_name"
                        )), 1),
                          _createElementVNode("th", _hoisted_48, _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.preview_learners.table.last_name"
                        )), 1),
                          _createElementVNode("th", _hoisted_49, _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.preview_learners.table.student_number"
                        )), 1),
                          _createElementVNode("th", _hoisted_50, _toDisplayString(_ctx.$t(
                          "bulk_learner_upload_component.preview_learners.table.password"
                        )), 1)
                        ])
                      ]),
                      _createElementVNode("tbody", _hoisted_51, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(learnersToUpload.value, (learner, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            class: "rounded-lg",
                            key: index
                          }, [
                            _createElementVNode("td", _hoisted_52, [
                              _createVNode(_component_UserIcon, { class: "w-5 h-5 text-gray-500" })
                            ]),
                            _createElementVNode("td", _hoisted_53, [
                              _createVNode(_component_FormKit, {
                                id: learner.email,
                                type: "text",
                                modelValue: learner.email,
                                "onUpdate:modelValue": ($event: any) => ((learner.email) = $event),
                                placeholder: "Learner Email",
                                classes: {
                          outer: '',
                          wrapper: 'w-11/12',
                          message: 'text-red-500 text-xs px-3',
                          input:
                            'w-full text-gray-600 text-sm border-none py-2 h-10 rounded-lg focus:outline-none',
                        },
                                validation: "required|email_exists",
                                "validation-rules": { email_exists: _ctx.email_exists },
                                "validation-visibility": "live",
                                "validation-messages": {
                          email_exists: _ctx.$t(
                            'bulk_learner_upload_component.preview_learners.email_validation'
                          ),
                        }
                              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "validation-rules", "validation-messages"])
                            ]),
                            _createElementVNode("td", _hoisted_54, _toDisplayString(learner.firstName), 1),
                            _createElementVNode("td", _hoisted_55, _toDisplayString(learner.lastName), 1),
                            _createElementVNode("td", _hoisted_56, _toDisplayString(learner.studentNumber), 1),
                            _createElementVNode("td", _hoisted_57, _toDisplayString("•".repeat(learner.password.length)), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("button", {
                    onClick: clearPreviewLearners,
                    type: "button",
                    class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 flex items-center shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
                  }, [
                    _createElementVNode("span", _hoisted_60, [
                      _createVNode(_component_rl_icon, {
                        icon: 'rl-small-back-arrow',
                        title: 'rl small back arrow',
                        "aria-hidden": "true"
                      })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_back")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("button", {
                    onClick: clearPreviewLearners,
                    type: "button",
                    class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent me-4 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] bg-white"
                  }, _toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_cancel")), 1),
                  _createVNode(_component_FormKit, {
                    type: "submit",
                    class: "rounded-lg py-2 px-4 text-white flex items-center font-semibold bg-blue-600 shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)]",
                    disabled: isSubmitting.value
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("bulk_learner_upload_component.preview_learners.btn_submit")), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmitInvalid", "validation-errors"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-2xl',
      open: confirmAssignLearnersModal.value,
      onLocalModalOpen: _cache[8] || (_cache[8] = ($event: any) => (confirmAssignLearnersModal.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_62, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-magnifying-glass',
                title: 'rl magnifying glass',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("h3", _hoisted_65, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.confirm_modal.header")), 1)
            ]),
            _createElementVNode("div", _hoisted_66, [
              _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.confirm_modal.selected_text")) + ":", 1),
              _createElementVNode("p", _hoisted_68, _toDisplayString(selectedLearners.value.length) + " " + _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.confirm_modal.text")) + " " + _toDisplayString(__props.selectedClassData.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (confirmAssignLearnersModal.value = false)),
              type: "button",
              class: "text-gray-700 border border-gray-300 rounded-lg p-2.5 text-base flex flex-row justify-center items-center flex-wrap w-1/2"
            }, _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.confirm_modal.edit")), 1),
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (addLearnersToClass.value())),
              type: "button",
              class: "bg-blue-600 rounded-lg p-2.5 text-base shadow-lg text-white flex flex-row justify-center items-center flex-wrap w-1/2"
            }, [
              (loadingSubmit.value)
                ? (_openBlock(), _createBlock(_component_spinner_loader, {
                    key: 0,
                    color: 'text-white dark:text-white mr-2'
                  }))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("overview_page.rollover_view.table_component.confirm_modal.correct")), 1)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})